import { Button, Dialog, DialogContent, DialogTitle, Typography } from "@material-ui/core"
import { useEffect, useState } from "react"
import { getJSONParametros } from "../../services/clientefiel"
import { pegarFaturasEmAberto } from "../../services/comum"

export const DialogAvisoFatura = () => {
    const idEstabelecimento = JSON.parse(localStorage.getItem("app-store"))?.state?.configuracoes
        ?.user?.parametros?.estabelecimento?.id
    const [open, setOpen] = useState(false)
    const [faturas, setFaturas] = useState([])
    const [erro, setErro] = useState("")

    // pegarFaturasEmAberto devolve {retornoErro, mensagem} quando o backend responde
    // codErro > 0 ou quando a requisição falha — nunca assumir array aqui.
    const handleClick = async () => {
        setOpen(true)
        try {
            const response = await pegarFaturasEmAberto(idEstabelecimento)
            if (Array.isArray(response)) {
                setFaturas(response)
                setErro("")
            } else {
                setFaturas([])
                setErro(response?.mensagem || "Não foi possível carregar as faturas.")
            }
        } catch (error) {
            console.error("Erro ao carregar faturas:", error)
            setFaturas([])
            setErro(error?.message || "Não foi possível carregar as faturas.")
        }
    }

    useEffect(() => {
        const getParametros = async () => {
            const params = await getJSONParametros(idEstabelecimento)
            if (!params) return
            localStorage.setItem("custom-params", JSON.stringify(params))
        }
        getParametros()
    }, [])

    // As FAIXAS de aviso de fatura agora ficam no topo (Cabeçalho, mesmo estilo do
    // alerta de impressão). Aqui mantemos só o DIÁLOGO, aberto pelo evento disparado
    // ao clicar na faixa.
    useEffect(() => {
        const abrir = () => handleClick()
        window.addEventListener("abrirFaturas", abrir)
        return () => window.removeEventListener("abrirFaturas", abrir)
    }, [])

    return (
        <>
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle id="form-dialog-title">Faturas abertas</DialogTitle>
                <DialogContent>
                    {erro && <Typography color="error">{erro}</Typography>}
                    {!erro && !faturas.length && (
                        <Typography>Nenhuma fatura em aberto no momento.</Typography>
                    )}
                    {faturas.map((fatura, indice) => {
                        return (
                            <div key={indice} style={{ marginBottom: "1em", width: "100%" }}>
                                <Typography>{fatura.descricao}</Typography>
                                <img
                                    width="300px"
                                    style={{ borderRadius: "20px" }}
                                    src={fatura.qrCodePix}
                                />
                                <div
                                    style={{
                                        width: "300px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        marginTop: "0.5em",
                                        marginBottom: "0.3em",
                                    }}
                                >
                                    <p
                                        style={{
                                            flex: 1,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            margin: 0,
                                        }}
                                    >
                                        {fatura.qrCodePixText}
                                    </p>
                                    <Button
                                        variant="contained"
                                        onClick={() => {
                                            navigator.clipboard
                                                .writeText(fatura.qrCodePixText)
                                                .then(() => {
                                                })
                                                .catch(err => {
                                                    console.error("Erro ao copiar:", err)
                                                })
                                        }}
                                    >
                                        Copiar
                                    </Button>
                                </div>
                                {/* urlFatura é a página de fatura da CF; url é a coluna crua
                                    (ora gateway, ora a própria CF) e fica só como fallback
                                    enquanto o backend novo não estiver publicado. */}
                                <a
                                    href={fatura.urlFatura || fatura.url}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{
                                        textDecoration: "underline",
                                    }}
                                >
                                    Ver fatura completa
                                </a>
                                <hr />
                            </div>
                        )
                    })}
                </DialogContent>
            </Dialog>
        </>
    )
}
